import { useTheme } from '@mui/material'

const CircleDownIcon = () => {
  const theme = useTheme()

  return (
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5002 32.5418C7.64059 32.5418 0.458496 25.3597 0.458496 16.5002C0.458496 7.64059 7.64059 0.458496 16.5002 0.458496C25.3597 0.458496 32.5418 7.64059 32.5418 16.5002C32.5418 25.3597 25.3597 32.5418 16.5002 32.5418ZM16.5002 29.6252C23.7489 29.6252 29.6252 23.7489 29.6252 16.5002C29.6252 9.25142 23.7489 3.37516 16.5002 3.37516C9.25142 3.37516 3.37516 9.25142 3.37516 16.5002C3.37516 23.7489 9.25142 29.6252 16.5002 29.6252ZM23.3647 14.6147L21.3023 12.5523L16.5002 17.3545L11.6981 12.5523L9.63567 14.6147L16.5002 21.4793L23.3647 14.6147Z"
        fill={theme.palette.custom.darkBlue2}
      />
    </svg>
  )
}

export default CircleDownIcon
